import {Checkbox} from 'platform/components';

import {useFormRenderer} from '@dms/teas';

import {VISIBLE_TYPE} from '../constants';
import {AuditStructureSettingsForm} from '../types';

type AuditSettingsParamValueCheckBoxProps = {
  paramDefinitionId: string;
  paramValueId: string;
  label: string;
};

export const AuditSettingsParamValueCheckBox = (props: AuditSettingsParamValueCheckBoxProps) => {
  const {Field, Subscribe} = useFormRenderer<AuditStructureSettingsForm>();

  return (
    <Subscribe
      name={`paramDefinitions.${props.paramDefinitionId}.${VISIBLE_TYPE}`}
      component={({input: parentVisibleInput}) => (
        <Field
          name={`paramDefinitions.${props.paramDefinitionId}.paramValues.${props.paramValueId}`}
          component={({input}) => {
            const isChecked =
              input.value === undefined || input.value === '' ? true : Boolean(input.value);

            return (
              <Checkbox
                label={props.label}
                value={isChecked}
                onChange={() => input.onChange(!isChecked)}
                isDisabled={parentVisibleInput.value === false}
              />
            );
          }}
        />
      )}
    />
  );
};
